// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Complementos visuais das telas de onboarding de marcas sobre o Shoreline
 * (Table, Pagination, Search, EmptyState, Checkbox, Menu, Tag). Somente
 * tokens \`--sl-*\` — nenhuma cor ou espaçamento literal.
 */

.JdxGD1zWeI8lljx1SQuC {
  flex: 1;
  background: var(--sl-bg-base);
  padding: var(--sl-space-6) var(--sl-space-8);
}

/*
 * O \`label { margin-bottom: 0.5rem }\` global do admin cai na raiz do
 * \`Checkbox\` e do \`Label\` do Shoreline, que são elementos \`label\`: o controle
 * sobe em relação ao texto ao lado.
 */

.JdxGD1zWeI8lljx1SQuC [data-sl-checkbox],
.XIiKwtMzOQqmB9TumPGg [data-sl-checkbox],
.wKnjIrWfutdMvNcmFQyT [data-sl-checkbox],
.wKnjIrWfutdMvNcmFQyT [data-sl-label] {
  align-items: center;
  margin-bottom: 0;
}

/* O indeterminado do Shoreline não é preenchido; aqui acompanha o marcado. */
.JdxGD1zWeI8lljx1SQuC
  [data-sl-checkbox-input][data-disabled='false'][data-indeterminate='true'],
.XIiKwtMzOQqmB9TumPGg
  [data-sl-checkbox-input][data-disabled='false'][data-indeterminate='true'] {
  background: var(--sl-bg-accent-strong);
  border: var(--sl-border-accent-strong);
  color: var(--sl-fg-inverted);
}

/* Cabeçalho da página: título + descrição à esquerda, controles à direita */

.cRctls6jzksndnHw3T5x {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--sl-space-4);
  padding-bottom: var(--sl-space-6);
  flex-wrap: wrap;
}

.qZBtcYe31V_OaK6YlzUh {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
  flex: 1;
  min-width: 0;
}

.MkoWKBSWS4KFAC0G3eQA {
  margin: 0;
  color: var(--sl-fg-base);
  font: var(--sl-text-display-1-font);
  letter-spacing: var(--sl-text-display-1-letter-spacing);
}

.jZ_Mw9XbsXv5NBgNFc4Y {
  margin: 0;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-body-font);
  letter-spacing: var(--sl-text-body-letter-spacing);
}

/* Dimensionado pelo conteúdo: encolher faria o \`Search\` transbordar sobre os botões. */
.n8Hn3tqruJovXdK5HeGa {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sl-space-2);
  flex-wrap: wrap;
  flex: 0 0 auto;
}

/* O \`Search\` do Shoreline tem \`min-width: 20rem\` próprio; respeitamos esse mínimo com um teto. */
.s3P0MUVnvFafo4JDrivB {
  flex: 0 1 20rem;
  min-width: 20rem;
  max-width: 24rem;
  overflow: hidden;
  transform-origin: right center;
  animation: PmHsgI8rbPxhG39Q3Nfg 160ms ease;
}

.ExNQ__aT1U0ykxa9a8aC {
  animation: tuk4mjQiuKMzXQllt9Fw 160ms ease forwards;
  pointer-events: none;
}

/*
 * O \`Search\` herda a cor do texto do app e marca o foco em cinza; aqui o
 * campo fica com o texto forte e o foco em azul, como os demais campos.
 * O \`!important\` no placeholder vence o reset global de \`main.css\`.
 */

.s3P0MUVnvFafo4JDrivB [data-sl-search],
.iU8dai7m6rX821w5S9up [data-sl-search],
.mA0q_dA_pCOZxPz166ug [data-sl-search] {
  color: var(--sl-fg-base);
}

.s3P0MUVnvFafo4JDrivB [data-sl-search] {
  box-shadow: var(--sl-shadow-1);
}

.s3P0MUVnvFafo4JDrivB [data-sl-search]:focus-within,
.iU8dai7m6rX821w5S9up [data-sl-search]:focus-within,
.mA0q_dA_pCOZxPz166ug [data-sl-search]:focus-within {
  border: var(--sl-border-accent-strong);
  box-shadow: var(--sl-focus-ring-accent);
}

.s3P0MUVnvFafo4JDrivB [data-sl-search-input]::placeholder,
.iU8dai7m6rX821w5S9up [data-sl-search-input]::placeholder,
.mA0q_dA_pCOZxPz166ug [data-sl-search-input]::placeholder {
  color: var(--sl-fg-base-soft) !important;
}

@keyframes PmHsgI8rbPxhG39Q3Nfg {
  from {
    min-width: 2.5rem;
    flex-basis: 2.5rem;
    opacity: 0.4;
  }

  to {
    min-width: 20rem;
    flex-basis: 20rem;
    opacity: 1;
  }
}

@keyframes tuk4mjQiuKMzXQllt9Fw {
  from {
    min-width: 20rem;
    flex-basis: 20rem;
    opacity: 1;
  }

  to {
    min-width: 2.5rem;
    flex-basis: 2.5rem;
    opacity: 0.4;
  }
}

/* Card que envolve a listagem */

.gdAxd2IlvZMSAf1o0FgG {
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-3);
  overflow: hidden;
}

.vOMKoAiJ3ou0ztQq6HYD {
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

/* Contagem à esquerda, paginação à direita. */
.s2SKUGHjoor85qQpsp_5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sl-space-4);
  border-top: var(--sl-border-base);
  padding: var(--sl-space-2) var(--sl-space-4);
}

/* A linha inteira abre o detalhe do produto. */
.otjy5cUUM7DtL432r50Y {
  cursor: pointer;
}

/* Nome da marca + contagem secundária empilhados */

.a6Xj3V4x2gH8SO16ilen {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.a66__D_lGmBDLdg1BcN9 {
  color: var(--sl-fg-base);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

/* Teto da coluna de marca, que é \`max-content\`: além dele, reticências. */
.EMlU0A17gbyNHnskce60 {
  max-width: 20rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* O \`Field\` do Shoreline é \`inline-flex\`: a largura o faz acompanhar o modal. */
.Y5X6pMbSjZqK_tHtmbOu,
.Y5X6pMbSjZqK_tHtmbOu > * {
  width: 100%;
  min-width: 0;
}

.hv08xfhn1jqy_d5SIzPX [data-sl-input] {
  color: var(--sl-fg-base);
}

.hv08xfhn1jqy_d5SIzPX [data-sl-input]:focus-within {
  border: var(--sl-border-accent-strong);
  box-shadow: var(--sl-focus-ring-accent);
}

.hv08xfhn1jqy_d5SIzPX [data-sl-input-element]::placeholder {
  color: var(--sl-fg-base-soft) !important;
}

.oTadgAeOPcj14iFGCyyw {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

/* Produto em "Meus produtos" sem marca vinculada */
.pqYnNN5OoTwVUOcpIHHX {
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

/* Link "N produtos →" com seta que aparece no hover */

.NLRneqmoXfIlxFOBwxSi {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-1);
  height: 2rem;
  padding: 0 0.625rem;
  margin-left: -0.625rem;
  border-radius: var(--sl-radius-2);
  border: none;
  background: transparent;
  white-space: nowrap;
  color: var(--sl-fg-base);
  text-decoration: none;
  transition: background-color 0.12s ease;
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

.NLRneqmoXfIlxFOBwxSi:hover {
  background: var(--sl-bg-muted);
  color: var(--sl-fg-base);
  text-decoration: none;
}

.OLJNrBVkFLaKrChh7qCq {
  display: inline-flex;
  opacity: 0;
  transform: translateX(-2px);
  transition:
    opacity 0.12s ease,
    transform 0.12s ease;
}

.NLRneqmoXfIlxFOBwxSi:hover .OLJNrBVkFLaKrChh7qCq {
  opacity: 1;
  transform: translateX(0);
}

.NLRneqmoXfIlxFOBwxSi:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-accent);
  outline-offset: 2px;
}

/* Célula de produto: thumb 40px + nome + meta (ID/EAN) */

.fflVU61tLQZxVhoPRG7S {
  display: flex;
  align-items: center;
  gap: var(--sl-space-3);
  min-width: 0;
}

.g0WJmjDcjd0wQpQP1CGg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--sl-radius-1);
  overflow: hidden;
  flex-shrink: 0;
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  color: var(--sl-fg-base-soft);
}

.g0WJmjDcjd0wQpQP1CGg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.DlI7jOPyt2UGDgLrMK6g {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
  min-width: 0;
}

.JVXNMY_Ky0hqrDEsloAQ {
  color: var(--sl-fg-base);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

.utjHIdPhRUc9VpR5Lowz {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  min-width: 0;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

.GtJJuFhktfRSFWc83Lnx {
  flex-shrink: 0;
}

.OqEL1aiCOI81rUZhEAwS {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

/* Bulk bar — sticky no rodapé da coluna de conteúdo */

.XlBwXaJ69tViegZJR7dN {
  position: sticky;
  bottom: var(--sl-space-6);
  display: flex;
  justify-content: center;
  margin-top: var(--sl-space-6);
  pointer-events: none;
  z-index: 50;
}

.X0M5BMw1YhSoCfm7oRUw {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-1);
  min-height: 3.25rem;
  padding: 0.375rem 0.375rem 0.375rem var(--sl-space-4);
  background: var(--sl-bg-inverted);
  color: var(--sl-fg-inverted);
  border-radius: var(--sl-radius-3);
  box-shadow: var(--sl-shadow-1);
  animation: i5_Dm0oSN_0pqqspy68n 180ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

@keyframes i5_Dm0oSN_0pqqspy68n {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

._uCIXLTgAmaHxSQRE550 {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
  white-space: nowrap;
  padding-right: var(--sl-space-3);
  color: color-mix(in srgb, var(--sl-fg-inverted) 70%, transparent);
  font: var(--sl-text-caption-1-font);
  letter-spacing: var(--sl-text-caption-1-letter-spacing);
}

.zJPN25W5Qv7j7ctibjxT {
  width: 1px;
  height: var(--sl-space-6);
  background: color-mix(in srgb, var(--sl-bg-base) 12%, transparent);
  margin: 0 var(--sl-space-1);
}

.wmcTkugt36bzJFdDgElv {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
  height: 2.5rem;
  padding: 0 0.875rem;
  border-radius: var(--sl-radius-2);
  border: none;
  background: transparent;
  color: var(--sl-fg-inverted);
  cursor: pointer;
  transition: background-color 0.12s ease;
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

.wmcTkugt36bzJFdDgElv:hover {
  background: color-mix(in srgb, var(--sl-bg-base) 8%, transparent);
}

.wmcTkugt36bzJFdDgElv:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-accent);
  outline-offset: 1px;
}

.Bv1zRKnuxupRznP1SjKo {
  color: var(--sl-color-red-6);
}

.Bv1zRKnuxupRznP1SjKo:hover {
  background: color-mix(in srgb, var(--sl-bg-critical-strong) 12%, transparent);
}

.Tw5e4DrZg3koFzufIWdd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-left: 2px;
  border: none;
  border-radius: var(--sl-radius-2);
  background: transparent;
  color: color-mix(in srgb, var(--sl-fg-inverted) 70%, transparent);
  cursor: pointer;
  transition:
    background-color 0.12s ease,
    color 0.12s ease;
}

.Tw5e4DrZg3koFzufIWdd:hover {
  background: color-mix(in srgb, var(--sl-bg-base) 8%, transparent);
  color: var(--sl-fg-inverted);
}

/* O \`EmptyState\` do Shoreline não define padding próprio. */
.E_A3ahrBE8YgE7da0SXh {
  padding: var(--sl-space-16) var(--sl-space-6) var(--sl-space-20);
}

/* O traço do ícone do Shoreline é fixo em 1.5px; ampliado, precisa escalar. */

.xLrQSfWdRa0Tw7R95tdd [data-sl-icon] *,
.upWvRFY4eRtpKCYj8Fy4 [data-sl-icon] * {
  vector-effect: none;
}

/* Ícone em círculo do empty state (o EmptyState do Shoreline não traz) */

.xLrQSfWdRa0Tw7R95tdd {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  margin-bottom: 0.625rem;
  border-radius: var(--sl-radius-full);
  background: var(--sl-bg-muted);
  color: var(--sl-fg-base-soft);
}

/* Drawer de filtros */

/* Badge posicionado fora do fluxo do botão, para não ser cortado pelo canto arredondado. */
.LSHER_XoMpWw85cVhVzw {
  position: relative;
  display: inline-flex;
}

.q3h43dhTNZKVCDuTX9Gt {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem;
  height: 1rem;
  padding: 0 var(--sl-space-1);
  border-radius: var(--sl-radius-full);
  background: var(--sl-bg-accent-strong);
  color: var(--sl-fg-inverted);
  pointer-events: none;
  font: var(--sl-text-caption-1-font);
  letter-spacing: var(--sl-text-caption-1-letter-spacing);
}

/*
 * O \`Content\` do SidePanelModal não define padding próprio. Quem rola é o
 * corpo, com o rodapé fixo: o painel não abre uma segunda barra de rolagem
 * sobre o conteúdo.
 */

.wKnjIrWfutdMvNcmFQyT {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.kgx5T9Uiehic5uL1xj0O {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--sl-space-2) var(--sl-space-6) var(--sl-space-4);
  border-top: var(--sl-border-base);
}

.HQ29pGnpDZJiDM3qDJ48 {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-2);
}

.Ca9PwSN4mBfA1UD0RABN {
  display: flex;
  align-items: center;
  gap: var(--sl-space-2);
  width: 100%;
  padding: var(--sl-space-2) 0;
  border: none;
  background: transparent;
  color: var(--sl-fg-base);
  cursor: pointer;
  font: var(--sl-text-emphasis-font);
  letter-spacing: var(--sl-text-emphasis-letter-spacing);
}

.KqrelB0KFe5nczipgatM {
  margin-right: auto;
}

.H2njfolzHFmoDTCdetVn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 var(--sl-space-1);
  border-radius: var(--sl-radius-full);
  background: var(--sl-bg-muted);
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-1-font);
  letter-spacing: var(--sl-text-caption-1-letter-spacing);
}

/* O drawer (300px) é mais estreito que o mínimo padrão do \`Search\` (20rem). */
.iU8dai7m6rX821w5S9up [data-sl-search] {
  --sl-search-min-width: 0;
  min-width: 0;
  width: 100%;
}

.RxGrnFNu457LEaFyfXnB {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-2);
}

.A6Eu8XGGMflHjMbrmf8C {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  gap: var(--sl-space-2);
  padding: var(--sl-space-4) var(--sl-space-6);
  border-top: var(--sl-border-base);
}

/* Título + subtitulo agrupados no header do modal, ao lado do botão de fechar */

.ML7ThHOyP837EeZHtJ9r {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
  min-width: 0;
  flex: 1;
}

/* Dentro do modal o \`Search\` ocupa a largura toda, sem o \`min-width\` padrão. */
.mA0q_dA_pCOZxPz166ug {
  margin: var(--sl-space-3) 0;
}

.mA0q_dA_pCOZxPz166ug [data-sl-search] {
  --sl-search-min-width: 0;
  min-width: 0;
  width: 100%;
}

.wH0tIT03lSAb6LYTrWJP {
  margin: var(--sl-space-1) 0 0;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

/* Lista de sugestões / resultados de busca dentro dos modais */

.yW3xgl2G7NV9dpCzRHjN {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
}

.S1n5skzkS1qD7ZLg10wh {
  display: flex;
  align-items: center;
  gap: var(--sl-space-3);
  padding: var(--sl-space-2);
  border-bottom: var(--sl-border-base);
  border-radius: var(--sl-radius-1);
  transition: background-color 0.12s ease;
}

.ZZNwioMhR2iwNrtcweJU {
  cursor: pointer;
}

.ZZNwioMhR2iwNrtcweJU:hover {
  background: var(--sl-bg-base-soft);
}

.fpgtmdAhJzsIXZnVZJIP,
.fpgtmdAhJzsIXZnVZJIP:hover {
  cursor: default;
  background: transparent;
}

.S1n5skzkS1qD7ZLg10wh:last-child {
  border-bottom: none;
}

.S1n5skzkS1qD7ZLg10wh .DlI7jOPyt2UGDgLrMK6g {
  flex: 1;
}

/* Corpo da linha: botão nativo sem os estilos próprios do controle. */

.jBXzGUNqQYmJJcbjx1i0 {
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--sl-space-3);
  min-width: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  text-align: left;
  cursor: inherit;
}

/* Dropzone do import de planilha */

.upWvRFY4eRtpKCYj8Fy4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sl-space-2);
  padding: var(--sl-space-8) var(--sl-space-4);
  border: 1px dashed var(--sl-border-base-color, var(--sl-fg-base-soft));
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-base-soft);
  color: var(--sl-fg-base-soft);
  cursor: pointer;
  text-align: center;
  transition:
    background-color 0.12s ease,
    border-color 0.12s ease;
}

/* O gatilho de anexo é botão nativo e precisa ocupar a largura do modal. */

.gdr9JkjaODqg7lLeRMDI {
  width: 100%;
}

.upWvRFY4eRtpKCYj8Fy4:hover,
.BHLJ16MATv_oD0xVIBOg {
  background: var(--sl-bg-muted);
  border-color: var(--sl-fg-accent);
  color: var(--sl-fg-base);
}

.tezjEPsQOsXYueQqs1zD {
  color: var(--sl-fg-base);
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

/* Banner global de sugestões e coluna de marca sugerida */

.iiqyFunduhCpNpg6acdK {
  display: flex;
  align-items: center;
  gap: var(--sl-space-3);
  padding: var(--sl-space-3) var(--sl-space-3) var(--sl-space-3)
    var(--sl-space-4);
  margin-bottom: var(--sl-space-4);
  border: var(--sl-border-informational);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-informational);
}

.D9WAOYEGFQgkn6QthZEJ {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--sl-fg-informational);
}

.jOqJdnNAmacgCtKHQJTu {
  flex: 1;
  margin: 0;
  color: var(--sl-fg-base);
  font: var(--sl-text-body-font);
  letter-spacing: var(--sl-text-body-letter-spacing);
}

.jOqJdnNAmacgCtKHQJTu strong {
  font: var(--sl-text-emphasis-font);
  letter-spacing: var(--sl-text-emphasis-letter-spacing);
}

.fxo_SUBWsN3KDVFFXmpX {
  height: fit-content;
  padding: var(--sl-space-3);
  border: none;
  border-radius: var(--sl-radius-2);
  background: none;
  color: var(--sl-fg-accent);
  white-space: nowrap;
  cursor: pointer;
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

.fxo_SUBWsN3KDVFFXmpX:hover {
  background: var(--sl-bg-accent-plain-hover);
}

.w09bs4GQCUtwE0kgLFBX {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  border: none;
  border-radius: var(--sl-radius-2);
  background: transparent;
  color: var(--sl-fg-base-soft);
  cursor: pointer;
  transition:
    background-color 0.12s ease,
    color 0.12s ease;
}

.w09bs4GQCUtwE0kgLFBX:hover {
  background: var(--sl-bg-muted);
  color: var(--sl-fg-base);
}

.w09bs4GQCUtwE0kgLFBX:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-accent);
}

/* Cabeçalho das listas dentro dos modais: selecionar todos + contagem */

/* Acima das linhas: checkbox e select do Shoreline criam contexto próprio. */
.GQdhEYpaj6ipWPO8o8XR {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: var(--sl-space-3);
  padding: var(--sl-space-2);
  border-bottom: var(--sl-border-base);
  background: var(--sl-bg-base);
}

/* A contagem cresce e alinha o rótulo de marca com a coluna das linhas. */

.GQdhEYpaj6ipWPO8o8XR .vOMKoAiJ3ou0ztQq6HYD {
  flex: 1;
  min-width: 0;
}

.GQdhEYpaj6ipWPO8o8XR .KylaJzed2JXGQh1GpVCU {
  flex: 0 0 13rem;
}

.fpgtmdAhJzsIXZnVZJIP {
  opacity: 0.55;
}

.g0Jvkos11507DFjkkTEZ {
  color: var(--sl-fg-base-soft);
  white-space: nowrap;
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

/* Encontrados e sem correspondência lado a lado, como uma linha só de resumo */

.LD4wKsZ0gvYlXT8l8ATo {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--sl-space-1) var(--sl-space-3);
  padding: var(--sl-space-2) var(--sl-space-3);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-muted);
  color: var(--sl-fg-base);
  font: var(--sl-text-emphasis-font);
  letter-spacing: var(--sl-text-emphasis-letter-spacing);
}

.a5sDlBwfAW6QKs31aHia {
  min-width: 0;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-body-font);
  letter-spacing: var(--sl-text-body-letter-spacing);
}

/* AddProductsModal — aba "Importar lista": textarea + dropzone + resumo */

.kAs8o9VKSnbQGANS3ZZL {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-2);
}

/* sobrescreve o placeholder global (main.css) que força a cor forte de texto */
.kAs8o9VKSnbQGANS3ZZL [data-sl-textarea-input]::placeholder,
.XpEm5h9pM5CzrxA3JvPP [data-sl-textarea-input]::placeholder {
  color: var(--sl-fg-base-soft) !important;
}

/* O \`Textarea\` marca o foco só com um anel neutro; aqui acende como os demais. */
.kAs8o9VKSnbQGANS3ZZL [data-sl-textarea-input]:focus-within,
.XpEm5h9pM5CzrxA3JvPP [data-sl-textarea-input]:focus-within {
  border: var(--sl-border-accent-strong);
  box-shadow: var(--sl-focus-ring-accent);
}

/* o \`Textarea\` do Shoreline para em 20rem; aqui acompanha a largura do painel */
.kAs8o9VKSnbQGANS3ZZL [data-sl-textarea],
.XpEm5h9pM5CzrxA3JvPP [data-sl-textarea] {
  max-width: none;
}

/* O \`Field\` é \`inline-flex\`: sem largura, o campo fica do tamanho do conteúdo. */
.XpEm5h9pM5CzrxA3JvPP {
  width: 100%;
}

.kAs8o9VKSnbQGANS3ZZL [data-sl-textarea-input],
.XpEm5h9pM5CzrxA3JvPP [data-sl-textarea-input] {
  resize: vertical;
}

._aq5B9_XgyhvVkwEqCKH {
  display: flex;
  align-items: center;
  gap: var(--sl-space-2);
}

.y87OeqYN2SPoUVd0SDVX {
  margin-right: auto;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

/* Marca inferida por nome: o select fica roxo, com o sparkle dentro do controle */

/* O recuo do valor no \`OptionSelect\` sai destas duas medidas mais um respiro. */

.Vw_SPSw8_6gOkZegH63B {
  --suggested-icon-left: 0.625rem;
  --suggested-icon-size: 1rem;

  position: relative;
  display: inline-flex;
  width: 100%;
  min-width: 0;
}

.rLX7WRF5_VYaujcUc6bA {
  position: absolute;
  top: 50%;
  left: var(--suggested-icon-left);
  z-index: 1;
  width: var(--suggested-icon-size);
  height: var(--suggested-icon-size);
  transform: translateY(-50%);
  color: var(--sl-color-purple-11);
  pointer-events: none;
}

/* 13rem casa com o minWidth do controle do SelectSearchable — evita overflow horizontal na linha */
.KylaJzed2JXGQh1GpVCU {
  width: 13rem;
  flex-shrink: 0;
}

/* Painel lateral de detalhe do produto */

.UHnE64bbFTc44uo5ti_8 {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-4);
  padding: var(--sl-space-4) var(--sl-space-6);
}

.hU6sm4O3qJcZ1Ztnrqdu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.5rem;
  height: 5.5rem;
  border-radius: var(--sl-radius-2);
  overflow: hidden;
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  color: var(--sl-fg-base-soft);
}

.hU6sm4O3qJcZ1Ztnrqdu img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.kBM0FdMUJWt3m5C0456r {
  margin: 0;
  color: var(--sl-fg-base);
  font: var(--sl-text-display-3-font);
  letter-spacing: var(--sl-text-display-3-letter-spacing);
}

.N5EvHPdoZJmEIz2Fr9PK {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
  margin: 0;
}

.N5EvHPdoZJmEIz2Fr9PK dt {
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}

.N5EvHPdoZJmEIz2Fr9PK dd {
  margin: 0 0 var(--sl-space-4);
  color: var(--sl-fg-base);
  font: var(--sl-text-body-font);
  letter-spacing: var(--sl-text-body-letter-spacing);
}

.bNridjtlXtZExLPzev18 {
  display: flex;
  justify-content: flex-end;
  gap: var(--sl-space-2);
  padding-top: var(--sl-space-4);
  border-top: var(--sl-border-base);
}

/*
 * Seletor de produtos dentro do modal de nova marca. O piso garante lista
 * utilizável mesmo quando o nome da marca e o rodapé comem a altura do modal;
 * com espaço sobrando, o \`flex\` passa do piso.
 */

.l7oRQSpvcDiNjioXyItb {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: min(20rem, 45dvh);
  margin-top: var(--sl-space-4);
}

/* Review do import: chips de resumo e destaque das linhas com erro */

.R2aONpsxDAGSwLbmaA_C {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sl-space-2);
  margin-bottom: var(--sl-space-4);
}

.FxW8JDWKiXagnf031n69 {
  background: var(--sl-bg-critical);
}

/* Chip de desfecho da linha do import: ponto + rótulo, tonal por desfecho */

.gnppdeKjMLHALSVoWSWj {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  height: 1.5rem;
  padding: 0 var(--sl-space-2);
  border: var(--sl-border-base-strong);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-base);
  box-shadow: var(--sl-shadow-1);
  color: var(--sl-fg-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font: var(--sl-text-emphasis-font);
  letter-spacing: var(--sl-text-emphasis-letter-spacing);
}

.exkUINcSw7JpEDRporcr {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: var(--sl-radius-full);
  background: var(--sl-bg-base-strong);
}

.FjBHoQ832P5J0P0ew5w5 {
  border: var(--sl-border-accent);
  background: var(--sl-bg-accent);
  color: var(--sl-fg-accent);
}

.FjBHoQ832P5J0P0ew5w5 .exkUINcSw7JpEDRporcr {
  background: var(--sl-bg-accent-strong);
}

.OFK2Ki5pWYI1nI2YbFuN {
  border: var(--sl-border-success);
  background: var(--sl-bg-success);
  color: var(--sl-fg-success);
}

.OFK2Ki5pWYI1nI2YbFuN .exkUINcSw7JpEDRporcr {
  background: var(--sl-fg-success);
}

.Lcn8Sdr3TBmO6CVq69jD {
  border: var(--sl-border-warning);
  background: var(--sl-bg-warning);
  color: var(--sl-fg-warning);
}

.Lcn8Sdr3TBmO6CVq69jD .exkUINcSw7JpEDRporcr {
  background: var(--sl-fg-warning);
}

.CJUAWM_m5SCkKiUudhNK {
  border: var(--sl-border-critical);
  background: var(--sl-bg-critical);
  color: var(--sl-fg-critical);
}

/* Quadrado para não depender só da cor. */
.CJUAWM_m5SCkKiUudhNK .exkUINcSw7JpEDRporcr {
  border-radius: 1px;
  background: var(--sl-bg-critical-strong);
}

.f1SksIdi0ikirIwxMrw2 {
  color: var(--sl-fg-base-soft);
}

/* Dropzone com arquivo carregado */
.P3bwHoWfd_jtQONg6b20 {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-1);
}

/* Link "baixar modelo" alinhado à esquerda do rodapé do modal */
.ISjkAmtEbQLpBIVwq3Cw {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-1);
  margin-right: auto;
  color: var(--sl-fg-accent);
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

/* Modal \`small\` com folga para nome de marca; os atributos batem a
   especificidade com que o Shoreline define \`--sl-modal-width\`. */
.imCAcT40iAs_QoVgfsOj[data-sl-modal][data-size='small'] {
  --sl-modal-width: 28.75rem;
}

/*
 * Altura travada no modal: quem rola é a lista, não a janela inteira. O
 * scroll do Shoreline fica no container, não no \`[data-sl-modal]\` externo.
 */

.XIiKwtMzOQqmB9TumPGg [data-sl-modal-container] {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 60rem;
  overflow: hidden;
}

/* Sticky sem \`z-index\` no tema: as linhas passavam por cima ao rolar. */
.XIiKwtMzOQqmB9TumPGg [data-sl-modal-header] {
  z-index: 3;
}

.XIiKwtMzOQqmB9TumPGg [data-sl-modal-header],
.XIiKwtMzOQqmB9TumPGg [data-sl-modal-footer] {
  flex: 0 0 auto;
}

.ecwb8h7qCmGCpZXzXxO6 {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.CK2PgW9Uj__aU__3sSJS {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.h10VnORxzcVNUUAd6orl {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.vmsnhVvhzoypYo1VSndF {
  display: inline-flex;
  align-self: flex-start;
  gap: 2px;
  padding: 3px;
  margin-bottom: var(--sl-space-3);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-muted);
  flex-shrink: 0;
}

.vuz6_lKXMjv2Rswdoa1z {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
  padding: var(--sl-space-2) var(--sl-space-4);
  border: none;
  border-radius: var(--sl-radius-1);
  background: none;
  color: var(--sl-fg-base-soft);
  cursor: pointer;
  transition:
    background-color 0.12s ease,
    color 0.12s ease;
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

.vuz6_lKXMjv2Rswdoa1z:hover {
  color: var(--sl-fg-base);
}

.SMEdJGiOJNgbpbHEpGVG {
  background: var(--sl-bg-base);
  color: var(--sl-fg-base);
  box-shadow: var(--sl-shadow-1);
}

/*
 * O \`RadioGroup\` do Shoreline é \`inline-flex\` e alinha os filhos ao início:
 * dentro do painel precisa esticar. O gap zerado tira o espaço do rótulo,
 * que fica oculto.
 */

.EW8uqJWtbbt3qLubD1Y8 {
  width: 100%;
  gap: 0;
}

.EW8uqJWtbbt3qLubD1Y8 [data-sl-stack] {
  --sl-stack-align: stretch;
}

/* Sugestões de marca: produto · EAN · marca sugerida */

.vSuRkiHS_d85TFBV2614 {
  display: flex;
  flex-direction: column;
  max-height: 24rem;
  overflow-y: auto;
}

.DsfvkeBZk27vsh9DPQnN,
.i3Jn99q9srlj2WYCWc7A {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 8rem 14rem;
  align-items: center;
  column-gap: var(--sl-space-4);
  padding: 0 var(--sl-space-1);
}

.DsfvkeBZk27vsh9DPQnN {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 2.75rem;
  background: var(--sl-bg-base);
  border-bottom: var(--sl-border-base);
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-emphasis-font);
  letter-spacing: var(--sl-text-emphasis-letter-spacing);
}

.i3Jn99q9srlj2WYCWc7A {
  min-height: 3.75rem;
  border-bottom: var(--sl-border-base);
}

.i3Jn99q9srlj2WYCWc7A:last-child {
  border-bottom: none;
}

/* Dica no lugar das linhas enquanto a lista de EANs não foi buscada */
.ROehMbg44uROE9EbxN0w {
  margin: 0;
  padding: var(--sl-space-8) var(--sl-space-2);
  text-align: center;
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/advertiserBrand/styles.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,OAAO;EACP,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;;;;EAIE;;AAEF;;;;EAIE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;;;;EAIE,sCAAsC;EACtC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA,uFAAuF;AACvF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA,iGAAiG;AACjG;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,0CAAgC;AAClC;;AAEA;EACE,mDAA2C;EAC3C,oBAAoB;AACtB;;AAEA;;;;EAIE;;AAEF;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA,gCAAgC;;AAEhC;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA,+CAA+C;AAC/C;EACE,eAAe;AACjB;;AAEA,mDAAmD;;AAEnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,mDAAmD;AACnD;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,sDAAsD;;AAEtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uCAAuC;EACvC,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,2BAA2B;EAC3B;;wBAEsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,sDAAsD;;AAEtD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qDAAqD;EACrD,iCAAiC;EACjC,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;EAC9B,oEAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,iEAAiE;EACjE,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,uCAAuC;EACvC,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;EACvB,iEAAiE;EACjE,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;EACE,gEAAgE;AAClE;;AAEA,8EAA8E;;AAE9E;;EAEE,mBAAmB;AACrB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,sBAAsB;;AAEtB,2FAA2F;AAC3F;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;EACpC,sCAAsC;EACtC,4BAA4B;EAC5B,oBAAoB;EACpB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,8DAA8D;EAC9D,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,8EAA8E;AAC9E;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA,sEAAsE;;AAEtE;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,sEAAsE;EACtE,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB;;2BAEyB;AAC3B;;AAEA,2EAA2E;;AAE3E;EACE,WAAW;AACb;;AAEA;;EAEE,8BAA8B;EAC9B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB;qBACmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,SAAS;EACT,wBAAwB;EACxB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA,wEAAwE;;AAExE,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,0EAA0E;;AAE1E;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,4CAA4C;EAC5C,iCAAiC;EACjC,8BAA8B;EAC9B,wBAAwB;EACxB,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E;;EAEE,wCAAwC;AAC1C;;AAEA,iFAAiF;AACjF;;EAEE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA,gFAAgF;AAChF;;EAEE,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,kFAAkF;;AAElF,gFAAgF;;AAEhF;EACE,+BAA+B;EAC/B,2BAA2B;;EAE3B,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,mGAAmG;AACnG;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,4EAA4E;;AAE5E;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;kEACkE;AAClE;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf;;oBAEkB;EAClB,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;;;EAIE;;AAEF;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,SAAS;EACT,4CAA4C;EAC5C,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,uDAAuD;AACzD","sourcesContent":["/*\n * Complementos visuais das telas de onboarding de marcas sobre o Shoreline\n * (Table, Pagination, Search, EmptyState, Checkbox, Menu, Tag). Somente\n * tokens `--sl-*` — nenhuma cor ou espaçamento literal.\n */\n\n.page {\n  flex: 1;\n  background: var(--sl-bg-base);\n  padding: var(--sl-space-6) var(--sl-space-8);\n}\n\n/*\n * O `label { margin-bottom: 0.5rem }` global do admin cai na raiz do\n * `Checkbox` e do `Label` do Shoreline, que são elementos `label`: o controle\n * sobe em relação ao texto ao lado.\n */\n\n.page [data-sl-checkbox],\n.pickerModal [data-sl-checkbox],\n.filterDrawer [data-sl-checkbox],\n.filterDrawer [data-sl-label] {\n  align-items: center;\n  margin-bottom: 0;\n}\n\n/* O indeterminado do Shoreline não é preenchido; aqui acompanha o marcado. */\n.page\n  [data-sl-checkbox-input][data-disabled='false'][data-indeterminate='true'],\n.pickerModal\n  [data-sl-checkbox-input][data-disabled='false'][data-indeterminate='true'] {\n  background: var(--sl-bg-accent-strong);\n  border: var(--sl-border-accent-strong);\n  color: var(--sl-fg-inverted);\n}\n\n/* Cabeçalho da página: título + descrição à esquerda, controles à direita */\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: var(--sl-space-4);\n  padding-bottom: var(--sl-space-6);\n  flex-wrap: wrap;\n}\n\n.titleGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-1);\n  flex: 1;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  color: var(--sl-fg-base);\n  font: var(--sl-text-display-1-font);\n  letter-spacing: var(--sl-text-display-1-letter-spacing);\n}\n\n.description {\n  margin: 0;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-body-font);\n  letter-spacing: var(--sl-text-body-letter-spacing);\n}\n\n/* Dimensionado pelo conteúdo: encolher faria o `Search` transbordar sobre os botões. */\n.headerActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--sl-space-2);\n  flex-wrap: wrap;\n  flex: 0 0 auto;\n}\n\n/* O `Search` do Shoreline tem `min-width: 20rem` próprio; respeitamos esse mínimo com um teto. */\n.headerSearch {\n  flex: 0 1 20rem;\n  min-width: 20rem;\n  max-width: 24rem;\n  overflow: hidden;\n  transform-origin: right center;\n  animation: searchGrow 160ms ease;\n}\n\n.headerSearchClosing {\n  animation: searchShrink 160ms ease forwards;\n  pointer-events: none;\n}\n\n/*\n * O `Search` herda a cor do texto do app e marca o foco em cinza; aqui o\n * campo fica com o texto forte e o foco em azul, como os demais campos.\n * O `!important` no placeholder vence o reset global de `main.css`.\n */\n\n.headerSearch [data-sl-search],\n.filterSearch [data-sl-search],\n.modalSearch [data-sl-search] {\n  color: var(--sl-fg-base);\n}\n\n.headerSearch [data-sl-search] {\n  box-shadow: var(--sl-shadow-1);\n}\n\n.headerSearch [data-sl-search]:focus-within,\n.filterSearch [data-sl-search]:focus-within,\n.modalSearch [data-sl-search]:focus-within {\n  border: var(--sl-border-accent-strong);\n  box-shadow: var(--sl-focus-ring-accent);\n}\n\n.headerSearch [data-sl-search-input]::placeholder,\n.filterSearch [data-sl-search-input]::placeholder,\n.modalSearch [data-sl-search-input]::placeholder {\n  color: var(--sl-fg-base-soft) !important;\n}\n\n@keyframes searchGrow {\n  from {\n    min-width: 2.5rem;\n    flex-basis: 2.5rem;\n    opacity: 0.4;\n  }\n\n  to {\n    min-width: 20rem;\n    flex-basis: 20rem;\n    opacity: 1;\n  }\n}\n\n@keyframes searchShrink {\n  from {\n    min-width: 20rem;\n    flex-basis: 20rem;\n    opacity: 1;\n  }\n\n  to {\n    min-width: 2.5rem;\n    flex-basis: 2.5rem;\n    opacity: 0.4;\n  }\n}\n\n/* Card que envolve a listagem */\n\n.card {\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-3);\n  overflow: hidden;\n}\n\n.count {\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n/* Contagem à esquerda, paginação à direita. */\n.cardFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sl-space-4);\n  border-top: var(--sl-border-base);\n  padding: var(--sl-space-2) var(--sl-space-4);\n}\n\n/* A linha inteira abre o detalhe do produto. */\n.clickableRow {\n  cursor: pointer;\n}\n\n/* Nome da marca + contagem secundária empilhados */\n\n.brandText {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.brandName {\n  color: var(--sl-fg-base);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n/* Teto da coluna de marca, que é `max-content`: além dele, reticências. */\n.brandCell {\n  max-width: 20rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* O `Field` do Shoreline é `inline-flex`: a largura o faz acompanhar o modal. */\n.brandField,\n.brandField > * {\n  width: 100%;\n  min-width: 0;\n}\n\n.brandNameField [data-sl-input] {\n  color: var(--sl-fg-base);\n}\n\n.brandNameField [data-sl-input]:focus-within {\n  border: var(--sl-border-accent-strong);\n  box-shadow: var(--sl-focus-ring-accent);\n}\n\n.brandNameField [data-sl-input-element]::placeholder {\n  color: var(--sl-fg-base-soft) !important;\n}\n\n.brandMeta {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n/* Produto em \"Meus produtos\" sem marca vinculada */\n.noBrand {\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n/* Link \"N produtos →\" com seta que aparece no hover */\n\n.usageLink {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-1);\n  height: 2rem;\n  padding: 0 0.625rem;\n  margin-left: -0.625rem;\n  border-radius: var(--sl-radius-2);\n  border: none;\n  background: transparent;\n  white-space: nowrap;\n  color: var(--sl-fg-base);\n  text-decoration: none;\n  transition: background-color 0.12s ease;\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n.usageLink:hover {\n  background: var(--sl-bg-muted);\n  color: var(--sl-fg-base);\n  text-decoration: none;\n}\n\n.usageArrow {\n  display: inline-flex;\n  opacity: 0;\n  transform: translateX(-2px);\n  transition:\n    opacity 0.12s ease,\n    transform 0.12s ease;\n}\n\n.usageLink:hover .usageArrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.usageLink:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-accent);\n  outline-offset: 2px;\n}\n\n/* Célula de produto: thumb 40px + nome + meta (ID/EAN) */\n\n.productCell {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-3);\n  min-width: 0;\n}\n\n.thumb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: var(--sl-radius-1);\n  overflow: hidden;\n  flex-shrink: 0;\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  color: var(--sl-fg-base-soft);\n}\n\n.thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.productText {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-1);\n  min-width: 0;\n}\n\n.productName {\n  color: var(--sl-fg-base);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n.productMeta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  min-width: 0;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n.metaSep {\n  flex-shrink: 0;\n}\n\n.metaEllipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n/* Bulk bar — sticky no rodapé da coluna de conteúdo */\n\n.bulkBar {\n  position: sticky;\n  bottom: var(--sl-space-6);\n  display: flex;\n  justify-content: center;\n  margin-top: var(--sl-space-6);\n  pointer-events: none;\n  z-index: 50;\n}\n\n.bulkBarInner {\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-1);\n  min-height: 3.25rem;\n  padding: 0.375rem 0.375rem 0.375rem var(--sl-space-4);\n  background: var(--sl-bg-inverted);\n  color: var(--sl-fg-inverted);\n  border-radius: var(--sl-radius-3);\n  box-shadow: var(--sl-shadow-1);\n  animation: bulkBarIn 180ms cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n@keyframes bulkBarIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.bulkCount {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  white-space: nowrap;\n  padding-right: var(--sl-space-3);\n  color: color-mix(in srgb, var(--sl-fg-inverted) 70%, transparent);\n  font: var(--sl-text-caption-1-font);\n  letter-spacing: var(--sl-text-caption-1-letter-spacing);\n}\n\n.bulkDivider {\n  width: 1px;\n  height: var(--sl-space-6);\n  background: color-mix(in srgb, var(--sl-bg-base) 12%, transparent);\n  margin: 0 var(--sl-space-1);\n}\n\n.bulkAction {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  height: 2.5rem;\n  padding: 0 0.875rem;\n  border-radius: var(--sl-radius-2);\n  border: none;\n  background: transparent;\n  color: var(--sl-fg-inverted);\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n.bulkAction:hover {\n  background: color-mix(in srgb, var(--sl-bg-base) 8%, transparent);\n}\n\n.bulkAction:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-accent);\n  outline-offset: 1px;\n}\n\n.bulkActionCritical {\n  color: var(--sl-color-red-6);\n}\n\n.bulkActionCritical:hover {\n  background: color-mix(in srgb, var(--sl-bg-critical-strong) 12%, transparent);\n}\n\n.bulkClear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  margin-left: 2px;\n  border: none;\n  border-radius: var(--sl-radius-2);\n  background: transparent;\n  color: color-mix(in srgb, var(--sl-fg-inverted) 70%, transparent);\n  cursor: pointer;\n  transition:\n    background-color 0.12s ease,\n    color 0.12s ease;\n}\n\n.bulkClear:hover {\n  background: color-mix(in srgb, var(--sl-bg-base) 8%, transparent);\n  color: var(--sl-fg-inverted);\n}\n\n/* O `EmptyState` do Shoreline não define padding próprio. */\n.empty {\n  padding: var(--sl-space-16) var(--sl-space-6) var(--sl-space-20);\n}\n\n/* O traço do ícone do Shoreline é fixo em 1.5px; ampliado, precisa escalar. */\n\n.emptyIcon [data-sl-icon] *,\n.dropzone [data-sl-icon] * {\n  vector-effect: none;\n}\n\n/* Ícone em círculo do empty state (o EmptyState do Shoreline não traz) */\n\n.emptyIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 4rem;\n  height: 4rem;\n  margin-bottom: 0.625rem;\n  border-radius: var(--sl-radius-full);\n  background: var(--sl-bg-muted);\n  color: var(--sl-fg-base-soft);\n}\n\n/* Drawer de filtros */\n\n/* Badge posicionado fora do fluxo do botão, para não ser cortado pelo canto arredondado. */\n.filterTrigger {\n  position: relative;\n  display: inline-flex;\n}\n\n.filterBadge {\n  position: absolute;\n  top: -0.25rem;\n  right: -0.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1rem;\n  height: 1rem;\n  padding: 0 var(--sl-space-1);\n  border-radius: var(--sl-radius-full);\n  background: var(--sl-bg-accent-strong);\n  color: var(--sl-fg-inverted);\n  pointer-events: none;\n  font: var(--sl-text-caption-1-font);\n  letter-spacing: var(--sl-text-caption-1-letter-spacing);\n}\n\n/*\n * O `Content` do SidePanelModal não define padding próprio. Quem rola é o\n * corpo, com o rodapé fixo: o painel não abre uma segunda barra de rolagem\n * sobre o conteúdo.\n */\n\n.filterDrawer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.filterBody {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: var(--sl-space-2) var(--sl-space-6) var(--sl-space-4);\n  border-top: var(--sl-border-base);\n}\n\n.filterSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-2);\n}\n\n.filterSectionHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  width: 100%;\n  padding: var(--sl-space-2) 0;\n  border: none;\n  background: transparent;\n  color: var(--sl-fg-base);\n  cursor: pointer;\n  font: var(--sl-text-emphasis-font);\n  letter-spacing: var(--sl-text-emphasis-letter-spacing);\n}\n\n.filterSectionTitle {\n  margin-right: auto;\n}\n\n.filterSectionBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 var(--sl-space-1);\n  border-radius: var(--sl-radius-full);\n  background: var(--sl-bg-muted);\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-1-font);\n  letter-spacing: var(--sl-text-caption-1-letter-spacing);\n}\n\n/* O drawer (300px) é mais estreito que o mínimo padrão do `Search` (20rem). */\n.filterSearch [data-sl-search] {\n  --sl-search-min-width: 0;\n  min-width: 0;\n  width: 100%;\n}\n\n.filterOptions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-2);\n}\n\n.filterFooter {\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  gap: var(--sl-space-2);\n  padding: var(--sl-space-4) var(--sl-space-6);\n  border-top: var(--sl-border-base);\n}\n\n/* Título + subtitulo agrupados no header do modal, ao lado do botão de fechar */\n\n.modalHeading {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-1);\n  min-width: 0;\n  flex: 1;\n}\n\n/* Dentro do modal o `Search` ocupa a largura toda, sem o `min-width` padrão. */\n.modalSearch {\n  margin: var(--sl-space-3) 0;\n}\n\n.modalSearch [data-sl-search] {\n  --sl-search-min-width: 0;\n  min-width: 0;\n  width: 100%;\n}\n\n.searchHint {\n  margin: var(--sl-space-1) 0 0;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n/* Lista de sugestões / resultados de busca dentro dos modais */\n\n.suggestionList {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.suggestionRow {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-3);\n  padding: var(--sl-space-2);\n  border-bottom: var(--sl-border-base);\n  border-radius: var(--sl-radius-1);\n  transition: background-color 0.12s ease;\n}\n\n.suggestionRowClickable {\n  cursor: pointer;\n}\n\n.suggestionRowClickable:hover {\n  background: var(--sl-bg-base-soft);\n}\n\n.suggestionRowDisabled,\n.suggestionRowDisabled:hover {\n  cursor: default;\n  background: transparent;\n}\n\n.suggestionRow:last-child {\n  border-bottom: none;\n}\n\n.suggestionRow .productText {\n  flex: 1;\n}\n\n/* Corpo da linha: botão nativo sem os estilos próprios do controle. */\n\n.suggestionRowMain {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: var(--sl-space-3);\n  min-width: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  text-align: left;\n  cursor: inherit;\n}\n\n/* Dropzone do import de planilha */\n\n.dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--sl-space-2);\n  padding: var(--sl-space-8) var(--sl-space-4);\n  border: 1px dashed var(--sl-border-base-color, var(--sl-fg-base-soft));\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-base-soft);\n  color: var(--sl-fg-base-soft);\n  cursor: pointer;\n  text-align: center;\n  transition:\n    background-color 0.12s ease,\n    border-color 0.12s ease;\n}\n\n/* O gatilho de anexo é botão nativo e precisa ocupar a largura do modal. */\n\n.dropzoneButton {\n  width: 100%;\n}\n\n.dropzone:hover,\n.dropzoneActive {\n  background: var(--sl-bg-muted);\n  border-color: var(--sl-fg-accent);\n  color: var(--sl-fg-base);\n}\n\n.dropzoneFile {\n  color: var(--sl-fg-base);\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n/* Banner global de sugestões e coluna de marca sugerida */\n\n.suggestionBanner {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-3);\n  padding: var(--sl-space-3) var(--sl-space-3) var(--sl-space-3)\n    var(--sl-space-4);\n  margin-bottom: var(--sl-space-4);\n  border: var(--sl-border-informational);\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-informational);\n}\n\n.suggestionBannerIcon {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  color: var(--sl-fg-informational);\n}\n\n.suggestionBannerText {\n  flex: 1;\n  margin: 0;\n  color: var(--sl-fg-base);\n  font: var(--sl-text-body-font);\n  letter-spacing: var(--sl-text-body-letter-spacing);\n}\n\n.suggestionBannerText strong {\n  font: var(--sl-text-emphasis-font);\n  letter-spacing: var(--sl-text-emphasis-letter-spacing);\n}\n\n.suggestionBannerAction {\n  height: fit-content;\n  padding: var(--sl-space-3);\n  border: none;\n  border-radius: var(--sl-radius-2);\n  background: none;\n  color: var(--sl-fg-accent);\n  white-space: nowrap;\n  cursor: pointer;\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n.suggestionBannerAction:hover {\n  background: var(--sl-bg-accent-plain-hover);\n}\n\n.bannerDismiss {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  flex-shrink: 0;\n  border: none;\n  border-radius: var(--sl-radius-2);\n  background: transparent;\n  color: var(--sl-fg-base-soft);\n  cursor: pointer;\n  transition:\n    background-color 0.12s ease,\n    color 0.12s ease;\n}\n\n.bannerDismiss:hover {\n  background: var(--sl-bg-muted);\n  color: var(--sl-fg-base);\n}\n\n.bannerDismiss:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-accent);\n}\n\n/* Cabeçalho das listas dentro dos modais: selecionar todos + contagem */\n\n/* Acima das linhas: checkbox e select do Shoreline criam contexto próprio. */\n.suggestionListHeader {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-3);\n  padding: var(--sl-space-2);\n  border-bottom: var(--sl-border-base);\n  background: var(--sl-bg-base);\n}\n\n/* A contagem cresce e alinha o rótulo de marca com a coluna das linhas. */\n\n.suggestionListHeader .count {\n  flex: 1;\n  min-width: 0;\n}\n\n.suggestionListHeader .rowBrand {\n  flex: 0 0 13rem;\n}\n\n.suggestionRowDisabled {\n  opacity: 0.55;\n}\n\n.alreadyAdded {\n  color: var(--sl-fg-base-soft);\n  white-space: nowrap;\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n/* Encontrados e sem correspondência lado a lado, como uma linha só de resumo */\n\n.batchSummary {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: var(--sl-space-1) var(--sl-space-3);\n  padding: var(--sl-space-2) var(--sl-space-3);\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-muted);\n  color: var(--sl-fg-base);\n  font: var(--sl-text-emphasis-font);\n  letter-spacing: var(--sl-text-emphasis-letter-spacing);\n}\n\n.batchSummaryWarn {\n  min-width: 0;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-body-font);\n  letter-spacing: var(--sl-text-body-letter-spacing);\n}\n\n/* AddProductsModal — aba \"Importar lista\": textarea + dropzone + resumo */\n\n.batchPanel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-2);\n}\n\n/* sobrescreve o placeholder global (main.css) que força a cor forte de texto */\n.batchPanel [data-sl-textarea-input]::placeholder,\n.pasteField [data-sl-textarea-input]::placeholder {\n  color: var(--sl-fg-base-soft) !important;\n}\n\n/* O `Textarea` marca o foco só com um anel neutro; aqui acende como os demais. */\n.batchPanel [data-sl-textarea-input]:focus-within,\n.pasteField [data-sl-textarea-input]:focus-within {\n  border: var(--sl-border-accent-strong);\n  box-shadow: var(--sl-focus-ring-accent);\n}\n\n/* o `Textarea` do Shoreline para em 20rem; aqui acompanha a largura do painel */\n.batchPanel [data-sl-textarea],\n.pasteField [data-sl-textarea] {\n  max-width: none;\n}\n\n/* O `Field` é `inline-flex`: sem largura, o campo fica do tamanho do conteúdo. */\n.pasteField {\n  width: 100%;\n}\n\n.batchPanel [data-sl-textarea-input],\n.pasteField [data-sl-textarea-input] {\n  resize: vertical;\n}\n\n.batchActions {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n}\n\n.batchHint {\n  margin-right: auto;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n/* Marca inferida por nome: o select fica roxo, com o sparkle dentro do controle */\n\n/* O recuo do valor no `OptionSelect` sai destas duas medidas mais um respiro. */\n\n.suggestedSelect {\n  --suggested-icon-left: 0.625rem;\n  --suggested-icon-size: 1rem;\n\n  position: relative;\n  display: inline-flex;\n  width: 100%;\n  min-width: 0;\n}\n\n.suggestedIcon {\n  position: absolute;\n  top: 50%;\n  left: var(--suggested-icon-left);\n  z-index: 1;\n  width: var(--suggested-icon-size);\n  height: var(--suggested-icon-size);\n  transform: translateY(-50%);\n  color: var(--sl-color-purple-11);\n  pointer-events: none;\n}\n\n/* 13rem casa com o minWidth do controle do SelectSearchable — evita overflow horizontal na linha */\n.rowBrand {\n  width: 13rem;\n  flex-shrink: 0;\n}\n\n/* Painel lateral de detalhe do produto */\n\n.productDrawer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-4);\n  padding: var(--sl-space-4) var(--sl-space-6);\n}\n\n.productDrawerThumb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 5.5rem;\n  height: 5.5rem;\n  border-radius: var(--sl-radius-2);\n  overflow: hidden;\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  color: var(--sl-fg-base-soft);\n}\n\n.productDrawerThumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.productDrawerName {\n  margin: 0;\n  color: var(--sl-fg-base);\n  font: var(--sl-text-display-3-font);\n  letter-spacing: var(--sl-text-display-3-letter-spacing);\n}\n\n.productDrawerFields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-1);\n  margin: 0;\n}\n\n.productDrawerFields dt {\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n\n.productDrawerFields dd {\n  margin: 0 0 var(--sl-space-4);\n  color: var(--sl-fg-base);\n  font: var(--sl-text-body-font);\n  letter-spacing: var(--sl-text-body-letter-spacing);\n}\n\n.productDrawerFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--sl-space-2);\n  padding-top: var(--sl-space-4);\n  border-top: var(--sl-border-base);\n}\n\n/*\n * Seletor de produtos dentro do modal de nova marca. O piso garante lista\n * utilizável mesmo quando o nome da marca e o rodapé comem a altura do modal;\n * com espaço sobrando, o `flex` passa do piso.\n */\n\n.brandProducts {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: min(20rem, 45dvh);\n  margin-top: var(--sl-space-4);\n}\n\n/* Review do import: chips de resumo e destaque das linhas com erro */\n\n.reviewSummary {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--sl-space-2);\n  margin-bottom: var(--sl-space-4);\n}\n\n.reviewRowError {\n  background: var(--sl-bg-critical);\n}\n\n/* Chip de desfecho da linha do import: ponto + rótulo, tonal por desfecho */\n\n.chip {\n  display: inline-flex;\n  box-sizing: border-box;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  height: 1.5rem;\n  padding: 0 var(--sl-space-2);\n  border: var(--sl-border-base-strong);\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-base);\n  box-shadow: var(--sl-shadow-1);\n  color: var(--sl-fg-base);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font: var(--sl-text-emphasis-font);\n  letter-spacing: var(--sl-text-emphasis-letter-spacing);\n}\n\n.chipDot {\n  width: 6px;\n  height: 6px;\n  flex: 0 0 6px;\n  border-radius: var(--sl-radius-full);\n  background: var(--sl-bg-base-strong);\n}\n\n.chipAdd {\n  border: var(--sl-border-accent);\n  background: var(--sl-bg-accent);\n  color: var(--sl-fg-accent);\n}\n\n.chipAdd .chipDot {\n  background: var(--sl-bg-accent-strong);\n}\n\n.chipLink {\n  border: var(--sl-border-success);\n  background: var(--sl-bg-success);\n  color: var(--sl-fg-success);\n}\n\n.chipLink .chipDot {\n  background: var(--sl-fg-success);\n}\n\n.chipMove {\n  border: var(--sl-border-warning);\n  background: var(--sl-bg-warning);\n  color: var(--sl-fg-warning);\n}\n\n.chipMove .chipDot {\n  background: var(--sl-fg-warning);\n}\n\n.chipError {\n  border: var(--sl-border-critical);\n  background: var(--sl-bg-critical);\n  color: var(--sl-fg-critical);\n}\n\n/* Quadrado para não depender só da cor. */\n.chipError .chipDot {\n  border-radius: 1px;\n  background: var(--sl-bg-critical-strong);\n}\n\n.chipMuted {\n  color: var(--sl-fg-base-soft);\n}\n\n/* Dropzone com arquivo carregado */\n.dropzoneActions {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-1);\n}\n\n/* Link \"baixar modelo\" alinhado à esquerda do rodapé do modal */\n.footerLink {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-1);\n  margin-right: auto;\n  color: var(--sl-fg-accent);\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n/* Modal `small` com folga para nome de marca; os atributos batem a\n   especificidade com que o Shoreline define `--sl-modal-width`. */\n.brandModal[data-sl-modal][data-size='small'] {\n  --sl-modal-width: 28.75rem;\n}\n\n/*\n * Altura travada no modal: quem rola é a lista, não a janela inteira. O\n * scroll do Shoreline fica no container, não no `[data-sl-modal]` externo.\n */\n\n.pickerModal [data-sl-modal-container] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 60rem;\n  overflow: hidden;\n}\n\n/* Sticky sem `z-index` no tema: as linhas passavam por cima ao rolar. */\n.pickerModal [data-sl-modal-header] {\n  z-index: 3;\n}\n\n.pickerModal [data-sl-modal-header],\n.pickerModal [data-sl-modal-footer] {\n  flex: 0 0 auto;\n}\n\n.pickerModalContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.picker {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.pickerList {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.modeTabs {\n  display: inline-flex;\n  align-self: flex-start;\n  gap: 2px;\n  padding: 3px;\n  margin-bottom: var(--sl-space-3);\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-muted);\n  flex-shrink: 0;\n}\n\n.modeTab {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  padding: var(--sl-space-2) var(--sl-space-4);\n  border: none;\n  border-radius: var(--sl-radius-1);\n  background: none;\n  color: var(--sl-fg-base-soft);\n  cursor: pointer;\n  transition:\n    background-color 0.12s ease,\n    color 0.12s ease;\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n.modeTab:hover {\n  color: var(--sl-fg-base);\n}\n\n.modeTabActive {\n  background: var(--sl-bg-base);\n  color: var(--sl-fg-base);\n  box-shadow: var(--sl-shadow-1);\n}\n\n/*\n * O `RadioGroup` do Shoreline é `inline-flex` e alinha os filhos ao início:\n * dentro do painel precisa esticar. O gap zerado tira o espaço do rótulo,\n * que fica oculto.\n */\n\n.filterGroup {\n  width: 100%;\n  gap: 0;\n}\n\n.filterGroup [data-sl-stack] {\n  --sl-stack-align: stretch;\n}\n\n/* Sugestões de marca: produto · EAN · marca sugerida */\n\n.suggestionTable {\n  display: flex;\n  flex-direction: column;\n  max-height: 24rem;\n  overflow-y: auto;\n}\n\n.suggestionHead,\n.suggestionBodyRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 8rem 14rem;\n  align-items: center;\n  column-gap: var(--sl-space-4);\n  padding: 0 var(--sl-space-1);\n}\n\n.suggestionHead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  height: 2.75rem;\n  background: var(--sl-bg-base);\n  border-bottom: var(--sl-border-base);\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-emphasis-font);\n  letter-spacing: var(--sl-text-emphasis-letter-spacing);\n}\n\n.suggestionBodyRow {\n  min-height: 3.75rem;\n  border-bottom: var(--sl-border-base);\n}\n\n.suggestionBodyRow:last-child {\n  border-bottom: none;\n}\n\n/* Dica no lugar das linhas enquanto a lista de EANs não foi buscada */\n.pickerHint {\n  margin: 0;\n  padding: var(--sl-space-8) var(--sl-space-2);\n  text-align: center;\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-2-font);\n  letter-spacing: var(--sl-text-caption-2-letter-spacing);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `JdxGD1zWeI8lljx1SQuC`,
	"pickerModal": `XIiKwtMzOQqmB9TumPGg`,
	"filterDrawer": `wKnjIrWfutdMvNcmFQyT`,
	"header": `cRctls6jzksndnHw3T5x`,
	"titleGroup": `qZBtcYe31V_OaK6YlzUh`,
	"title": `MkoWKBSWS4KFAC0G3eQA`,
	"description": `jZ_Mw9XbsXv5NBgNFc4Y`,
	"headerActions": `n8Hn3tqruJovXdK5HeGa`,
	"headerSearch": `s3P0MUVnvFafo4JDrivB`,
	"searchGrow": `PmHsgI8rbPxhG39Q3Nfg`,
	"headerSearchClosing": `ExNQ__aT1U0ykxa9a8aC`,
	"searchShrink": `tuk4mjQiuKMzXQllt9Fw`,
	"filterSearch": `iU8dai7m6rX821w5S9up`,
	"modalSearch": `mA0q_dA_pCOZxPz166ug`,
	"card": `gdAxd2IlvZMSAf1o0FgG`,
	"count": `vOMKoAiJ3ou0ztQq6HYD`,
	"cardFooter": `s2SKUGHjoor85qQpsp_5`,
	"clickableRow": `otjy5cUUM7DtL432r50Y`,
	"brandText": `a6Xj3V4x2gH8SO16ilen`,
	"brandName": `a66__D_lGmBDLdg1BcN9`,
	"brandCell": `EMlU0A17gbyNHnskce60`,
	"brandField": `Y5X6pMbSjZqK_tHtmbOu`,
	"brandNameField": `hv08xfhn1jqy_d5SIzPX`,
	"brandMeta": `oTadgAeOPcj14iFGCyyw`,
	"noBrand": `pqYnNN5OoTwVUOcpIHHX`,
	"usageLink": `NLRneqmoXfIlxFOBwxSi`,
	"usageArrow": `OLJNrBVkFLaKrChh7qCq`,
	"productCell": `fflVU61tLQZxVhoPRG7S`,
	"thumb": `g0WJmjDcjd0wQpQP1CGg`,
	"productText": `DlI7jOPyt2UGDgLrMK6g`,
	"productName": `JVXNMY_Ky0hqrDEsloAQ`,
	"productMeta": `utjHIdPhRUc9VpR5Lowz`,
	"metaSep": `GtJJuFhktfRSFWc83Lnx`,
	"metaEllipsis": `OqEL1aiCOI81rUZhEAwS`,
	"bulkBar": `XlBwXaJ69tViegZJR7dN`,
	"bulkBarInner": `X0M5BMw1YhSoCfm7oRUw`,
	"bulkBarIn": `i5_Dm0oSN_0pqqspy68n`,
	"bulkCount": `_uCIXLTgAmaHxSQRE550`,
	"bulkDivider": `zJPN25W5Qv7j7ctibjxT`,
	"bulkAction": `wmcTkugt36bzJFdDgElv`,
	"bulkActionCritical": `Bv1zRKnuxupRznP1SjKo`,
	"bulkClear": `Tw5e4DrZg3koFzufIWdd`,
	"empty": `E_A3ahrBE8YgE7da0SXh`,
	"emptyIcon": `xLrQSfWdRa0Tw7R95tdd`,
	"dropzone": `upWvRFY4eRtpKCYj8Fy4`,
	"filterTrigger": `LSHER_XoMpWw85cVhVzw`,
	"filterBadge": `q3h43dhTNZKVCDuTX9Gt`,
	"filterBody": `kgx5T9Uiehic5uL1xj0O`,
	"filterSection": `HQ29pGnpDZJiDM3qDJ48`,
	"filterSectionHeader": `Ca9PwSN4mBfA1UD0RABN`,
	"filterSectionTitle": `KqrelB0KFe5nczipgatM`,
	"filterSectionBadge": `H2njfolzHFmoDTCdetVn`,
	"filterOptions": `RxGrnFNu457LEaFyfXnB`,
	"filterFooter": `A6Eu8XGGMflHjMbrmf8C`,
	"modalHeading": `ML7ThHOyP837EeZHtJ9r`,
	"searchHint": `wH0tIT03lSAb6LYTrWJP`,
	"suggestionList": `yW3xgl2G7NV9dpCzRHjN`,
	"suggestionRow": `S1n5skzkS1qD7ZLg10wh`,
	"suggestionRowClickable": `ZZNwioMhR2iwNrtcweJU`,
	"suggestionRowDisabled": `fpgtmdAhJzsIXZnVZJIP`,
	"suggestionRowMain": `jBXzGUNqQYmJJcbjx1i0`,
	"dropzoneButton": `gdr9JkjaODqg7lLeRMDI`,
	"dropzoneActive": `BHLJ16MATv_oD0xVIBOg`,
	"dropzoneFile": `tezjEPsQOsXYueQqs1zD`,
	"suggestionBanner": `iiqyFunduhCpNpg6acdK`,
	"suggestionBannerIcon": `D9WAOYEGFQgkn6QthZEJ`,
	"suggestionBannerText": `jOqJdnNAmacgCtKHQJTu`,
	"suggestionBannerAction": `fxo_SUBWsN3KDVFFXmpX`,
	"bannerDismiss": `w09bs4GQCUtwE0kgLFBX`,
	"suggestionListHeader": `GQdhEYpaj6ipWPO8o8XR`,
	"rowBrand": `KylaJzed2JXGQh1GpVCU`,
	"alreadyAdded": `g0Jvkos11507DFjkkTEZ`,
	"batchSummary": `LD4wKsZ0gvYlXT8l8ATo`,
	"batchSummaryWarn": `a5sDlBwfAW6QKs31aHia`,
	"batchPanel": `kAs8o9VKSnbQGANS3ZZL`,
	"pasteField": `XpEm5h9pM5CzrxA3JvPP`,
	"batchActions": `_aq5B9_XgyhvVkwEqCKH`,
	"batchHint": `y87OeqYN2SPoUVd0SDVX`,
	"suggestedSelect": `Vw_SPSw8_6gOkZegH63B`,
	"suggestedIcon": `rLX7WRF5_VYaujcUc6bA`,
	"productDrawer": `UHnE64bbFTc44uo5ti_8`,
	"productDrawerThumb": `hU6sm4O3qJcZ1Ztnrqdu`,
	"productDrawerName": `kBM0FdMUJWt3m5C0456r`,
	"productDrawerFields": `N5EvHPdoZJmEIz2Fr9PK`,
	"productDrawerFooter": `bNridjtlXtZExLPzev18`,
	"brandProducts": `l7oRQSpvcDiNjioXyItb`,
	"reviewSummary": `R2aONpsxDAGSwLbmaA_C`,
	"reviewRowError": `FxW8JDWKiXagnf031n69`,
	"chip": `gnppdeKjMLHALSVoWSWj`,
	"chipDot": `exkUINcSw7JpEDRporcr`,
	"chipAdd": `FjBHoQ832P5J0P0ew5w5`,
	"chipLink": `OFK2Ki5pWYI1nI2YbFuN`,
	"chipMove": `Lcn8Sdr3TBmO6CVq69jD`,
	"chipError": `CJUAWM_m5SCkKiUudhNK`,
	"chipMuted": `f1SksIdi0ikirIwxMrw2`,
	"dropzoneActions": `P3bwHoWfd_jtQONg6b20`,
	"footerLink": `ISjkAmtEbQLpBIVwq3Cw`,
	"brandModal": `imCAcT40iAs_QoVgfsOj`,
	"pickerModalContent": `ecwb8h7qCmGCpZXzXxO6`,
	"picker": `CK2PgW9Uj__aU__3sSJS`,
	"pickerList": `h10VnORxzcVNUUAd6orl`,
	"modeTabs": `vmsnhVvhzoypYo1VSndF`,
	"modeTab": `vuz6_lKXMjv2Rswdoa1z`,
	"modeTabActive": `SMEdJGiOJNgbpbHEpGVG`,
	"filterGroup": `EW8uqJWtbbt3qLubD1Y8`,
	"suggestionTable": `vSuRkiHS_d85TFBV2614`,
	"suggestionHead": `DsfvkeBZk27vsh9DPQnN`,
	"suggestionBodyRow": `i3Jn99q9srlj2WYCWc7A`,
	"pickerHint": `ROehMbg44uROE9EbxN0w`
};
export default ___CSS_LOADER_EXPORT___;
